import { render, staticRenderFns } from "./ProfileQuotes.vue?vue&type=template&id=7acfabe6&"
import script from "./ProfileQuotes.vue?vue&type=script&lang=js&"
export * from "./ProfileQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports